export const constants = {
  GET_LOGS_REQUEST: 'GET_LOGS_REQUEST',
  GET_LOGS_SUCCESS: 'GET_LOGS_SUCCESS',
  GET_LOGS_FAILURE: 'GET_LOGS_FAILURE',
  GET_LOG_REQUEST: 'GET_LOG_REQUEST',
  GET_LOG_SUCCESS: 'GET_LOG_SUCCESS',
  GET_LOG_FAILURE: 'GET_LOG_FAILURE',
};
